import * as types from "./types";

export const assignUserTagRequest = (payload) => ({
  type: types.ASSIGN_USER_TAG_REQUEST,
  payload,
});

export const removeUserTagRequest = (payload) => ({
  type: types.REMOVE_USER_TAG_REQUEST,
  payload,
});

export const userTagResponse = (payload) => ({
  type: types.USER_TAG_RESPONSE,
  payload,
});
